import React, { useState, useEffect } from 'react';
import { Rss, TrendingUp, RefreshCw } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const fallbackHeadlines = [
  { title: 'AI Revolution Continues: New Breakthroughs in 2026', category: 'Technology', time_ago: '2h ago' },
  { title: 'Global Markets Rally on Economic Data', category: 'Finance', time_ago: '3h ago' },
  { title: 'Climate Summit Announces Major Green Initiatives', category: 'Environment', time_ago: '5h ago' },
  { title: 'SpaceX Plans Mars Mission Update', category: 'Science', time_ago: '6h ago' },
  { title: 'Quantum Computing Reaches New Milestone', category: 'Technology', time_ago: '8h ago' }
];

const LiveNewsTicker = () => {
  const [headlines, setHeadlines] = useState(fallbackHeadlines);
  const [loading, setLoading] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(null);

  const fetchNews = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/news/live`);
      if (response.data.headlines && response.data.headlines.length > 0) {
        setHeadlines(response.data.headlines);
        setLastUpdated(new Date());
      }
    } catch (error) {
      console.error('Failed to fetch news:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNews();
    // Refresh news every 15 minutes
    const interval = setInterval(fetchNews, 15 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Card className="w-full p-4 rounded-xl border bg-card/50 backdrop-blur-md" data-testid="live-news-ticker">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2">
            <Rss className="text-primary animate-pulse" size={18} />
            <h3 className="text-sm font-heading font-semibold text-foreground">Live News</h3>
          </div>
          <div className="flex items-center gap-1 text-xs text-muted-foreground">
            <TrendingUp size={14} />
            <span>Updated continuously</span>
          </div>
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={fetchNews}
          disabled={loading}
          className="h-8 w-8 p-0"
          data-testid="refresh-news-button"
        >
          <RefreshCw size={14} className={loading ? 'animate-spin' : ''} />
        </Button>
      </div>
      
      <div className="space-y-2">
        {headlines.map((headline, idx) => (
          <div 
            key={idx} 
            className="flex items-start justify-between p-2 rounded-lg hover:bg-background/50 transition-colors cursor-pointer group"
            data-testid={`news-headline-${idx}`}
          >
            <div className="flex-1">
              <p className="text-sm font-medium text-foreground group-hover:text-primary transition-colors">
                {headline.title}
              </p>
              <div className="flex items-center gap-2 mt-1">
                <span className="text-xs px-2 py-0.5 rounded-full bg-primary/10 text-primary">
                  {headline.category}
                </span>
                <span className="text-xs text-muted-foreground">{headline.time_ago}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default LiveNewsTicker;